import React from 'react';
import { Button } from '../../ui/button';
import { OnboardingStepProps } from '../types';

export const TeamSetup: React.FC<OnboardingStepProps> = ({ onNext }) => {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm text-gray-400">Team Name</label>
          <input
            type="text"
            className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white"
            placeholder="Enter team name"
          />
        </div>
        <div className="space-y-2">
          <label className="text-sm text-gray-400">Industry</label>
          <select className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white">
            <option value="">Select industry</option>
            <option value="technology">Technology</option>
            <option value="finance">Finance</option>
            <option value="healthcare">Healthcare</option>
          </select>
        </div>
        <div className="space-y-2">
          <label className="text-sm text-gray-400">Company Size</label>
          <select className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white">
            <option value="">Select size</option>
            <option value="1-50">1-50 employees</option>
            <option value="51-200">51-200 employees</option>
            <option value="201-1000">201-1000 employees</option>
            <option value="1000+">1000+ employees</option>
          </select>
        </div>
      </div>
      <Button className="w-full" onClick={onNext}>Continue</Button>
    </div>
  );
};